<template>
   <div class='provide_container'>
      <div id='buyerRation' class='provide_container'></div>
      <div class="pie-title">
        <span>
          全国地级行政区<br/>渗透率:<br/>{{percent}}<br/>
        </span>
        <div class='count-all'>全部{{countAll}}城市</div>
      </div>
   </div>
</template>

<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/line'
export default{

  data () {
    return {
      percent: '0%',
      count: 0,
      countAll: 0
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/maoming/market_share').then(res => {
        this.dataResponse = res.data
        let a = parseInt(this.dataResponse.data.source_citys_cnt)
        let b = parseInt(this.dataResponse.data.all_citys_cnt)
        this.percent = Math.floor(a / b * 100) + '%'
        this.count = a
        this.countAll = b
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 处理返回数据的格式
    dealData () {
      let a = parseInt(this.dataResponse.data.source_citys_cnt)
      let b = parseInt(this.dataResponse.data.all_citys_cnt)
      return [
        { value: a, name: '城' },
        { value: b - a, name: '城' }
      ]
    },
    // 根据数据初始化
    init () {
      var allCity = this.dataResponse.data.all_citys_cnt
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('buyerRation'))
      // 设置显示的数据
      var labelFromatter = {

        normal: {
          labelLine: {
            show: false
          },
          label: {
            show: false, // 是否显示标签
            formatter: function (params) {
              return parseInt(params.value / allCity * 100) + '%'
            },

            textStyle: {
              color: '#fff',
              fontSize: 20,
              baseline: 'middle'
            }

          }
        }
      }
      // 指定图表的配置项和数据
      var option = {
        color: ['#2390cd', '#fec52f'], // 蓝色 黄色
        series: [
          {
            name: '访问来源',
            type: 'pie',
            itemStyle: labelFromatter,

            radius: [80, 100],
            // center : ['30%', '30%'],
            // for funnel

            funnelAlign: 'left',
            max: 1048,
            data: this.dealData()
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    }
  },
  mounted () {
    this.getData(() => {
      this.init()
    })
  }
}

</script>
<style lang='less' scoped>
    .count-all{
      position:absolute;
      bottom:20px;
      color:#0efcff;
    }
    .pie-title span{
      font-size:16px;
      line-height:20px;
      text-align:center;
      color:#0efcff;
    }
   .pie-title{
     position:absolute;
     left:0;
     top:0;
     width:100%;
     height:100%;
     display:flex;
     align-items:center;
     justify-content:space-around;

   }
  .provide_container{
    width: 100%;
    height:100%;
    background:none;
    position:relative;
  }
</style>
